import {IntlShape} from "react-intl";
import {MTColumnsType} from "@utils/pagination";
import {QuotationAttachmentSchema} from "@feature/quotations";
import {downloadFileAndShowInTab, formatBytes, getSignedUrl} from "@pages/WorksitesDocuments/utils/FilesAndS3Utils";
import {MAX_SIZE} from "./consts";

export const checkUploadedAttachment = (file: any) => {

  if (!file)
    return { format: null, error: "No file" };
  let error = null;
  const re = /(?:\.([^.]+))?$/;
  const format = re.exec(file.name)?.[1];

  if (!format)
    error = file.name + " has unknown file format";

  if (MAX_SIZE) {
    const size = file.size;
    const kb = Math.round(size / 1024);
    if (MAX_SIZE < kb)
      error = file.name + " is too big";
  }

  return { format, error };
}

export const download = async (
  api: any,
  s3Url: string,
  name: string,
  bucketName: string,
  downloadFn: (signedUrl: string, name: string) => Promise<void>
) => {
  const signedUrl = await getSignedUrl(api, s3Url, name, bucketName);
  await downloadFn(signedUrl, name);
}

export const getColumns = (
  intl: IntlShape,
  countryApiRequest: any,
): MTColumnsType<QuotationAttachmentSchema> => [
  {
    title: intl.formatMessage({ id: 'name', defaultMessage: 'Nome' }),
    field: 'name',
    render: ({s3_url, name}) => {
      return (
        <div
          className="underline cursor-pointer"
          onClick={() => download(
            countryApiRequest, s3_url, name, 'quotations_attachments', downloadFileAndShowInTab
          )}
        >
          {name}
        </div>
      )
    }
  },
  {
    title: intl.formatMessage({ id: 'size', defaultMessage: 'Dimensione' }),
    field: 'size',
    render: ({size}) => formatBytes(size),
  },
  {
    title: intl.formatMessage({ id: 'created_by', defaultMessage: 'Creato da' }),
    field: 'des_creator',
  },
  {
    title: intl.formatMessage({ id: 'created_at', defaultMessage: 'Data di creazione' }),
    field: 'created_at',
    type: 'datetime'
  }
];